import { Pipe, PipeTransform } from '@angular/core';
import { JointEnum } from '@therapist/shared/models/diagnosis/joint.enum';

@Pipe({ name: 'jointNameTranslations' })
export class JointNameTranslationsPipe implements PipeTransform {

  transform(value: JointEnum, ...args: unknown[]): string {
    switch (value) {
      case JointEnum.Brustwirbelsaeule:
        return 'Brustwirbelsäule';

      case JointEnum.Halswirbelsaeule:
        return 'Halswirbelsäule';

      case JointEnum.Lendenwirbelsaeule:
        return 'Lendenwirbelsäule';

      case JointEnum.Schultergelenk:
        return 'Schulter';

      case JointEnum.Kniegelenk:
        return 'Knie';

      case JointEnum.Sprunggelenk:
        return 'Sprunggelenk';

      default:
        return '';
    }
  }
}
